import { debounce } from 'redux-saga/effects';
import { getQcsSyncResources } from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';

import { mkInvestmentSymbol } from './investmentSymbolsTypes';
import * as actions from './investmentSymbolsActions';

export function* getInvestmentSymbolsActionWatcher(): Generator<*, *, *> {
  const config = mkQcsSyncResourceConfig({
    resourceName: 'investment symbols lookup',
    resourceBaseUrl: '/v2/investments/symbol-lookup',
    getLastSyncDate: null,
    transformResponseToResources: (response) => response.data?.results?.map((item) => mkInvestmentSymbol({ id: item.symbol, ...item })),
    successAction: actions.getInvestmentSymbolsSuccess,
    failureAction: actions.getInvestmentSymbolsFailure,
    axiosConfig: { params: { limit: 50 } },
  });
  yield debounce(400, actions.getInvestmentSymbols, getQcsSyncResources, config);
}

export default [
  getInvestmentSymbolsActionWatcher,
];
